import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import linkIcon from "@phosphor-icons/core/regular/link.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const makeItRelevant: Tool = {
    urlSlug: "make-it-relevant",
    configName: "teacher-tool-make-it-relevant",
    title: () => t`Make it relevant`,
    description: () =>
        t`Link lesson content to students' lives and interests to boost engagement`,
    categories: [ToolCategories.Differentiate, ToolCategories.Support],
    icon: linkIcon,
    color: color.fadedRed24,
    layout: Layout.Coeditor,
    reportingLabelId: "make-it-relevant",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () =>
                t`e.g., Calculating the average rate of change of a polynomial between two points...`,
            inputKind: "TEXT_AREA",
            label: () => t`Learning objective(s)`,
            required: true,
            variableName: "topic",
        },
        {
            description: () =>
                t`e.g., Many students in my 6th grade class are big soccer fans...`,
            inputKind: "TEXT_AREA",
            label: () => t`Class profile`,
            required: true,
            variableName: "profile",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
